import { memo, useState } from 'react'

import Button from '../../Button'
import { NavArrowButton } from '../../NavArrow'

import * as styles from './TableScrollButton.module.css'

function TableScrollButton({
  className = styles.TableScrollButton,
  direction,
  disabled,
  visible,
  onClick,
}) {
  const [isHovered, setHover] = useState(false)

  const [closeTimeout, setCloseTimeout] = useState(null)

  function handleMouseEnter() {
    setHover(true)
  }

  function handleMouseLeave() {
    setHover(false)

    setCloseTimeout(
      setTimeout(() => {
        setCloseTimeout(null)
      }, 1000)
    )
  }

  return visible || isHovered || closeTimeout ? (
    <div
      className={className}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <NavArrowButton
        isLight
        Component={Button.Contained}
        direction={direction}
        disabled={disabled}
        onClick={onClick}
      />
    </div>
  ) : null
}

export default memo(TableScrollButton)
